import React from 'react';

import { WarningOutline } from '@depop/web-thrift-ui/Icons/WarningOutline';
import { Caption } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

type Props = {
  title: string;
  description: string;
};

export function SoldOutBanner({ title, description }: Props) {
  return (
    <div className={styles.soldOutBanner} role="status">
      <WarningOutline size="md" aria-hidden="true" />
      <div>
        <Caption variant="sm-bold" colour="base">
          {title}
        </Caption>
        <Caption variant="sm-regular" colour="base">
          {description}
        </Caption>
      </div>
    </div>
  );
}
